import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { theming } from 'styles/utils';
import { textSmall } from 'styles/typography';
export const wrapper = "omponents__Input__components__RuledPasswordInput__RuledPassword_styles_ts-wrapper-wav6jnu";
export const percentLineContainer = "omponents__Input__components__RuledPasswordInput__RuledPassword_styles_ts-percentLineContainer-pmf6uwd";
export const percentLineOuter = "omponents__Input__components__RuledPasswordInput__RuledPassword_styles_ts-percentLineOuter-p42ic5j";
export const PercentLineInner = /*#__PURE__*/styled("div")({
  name: "PercentLineInner",
  class: "omponents__Input__components__RuledPasswordInput__RuledPassword_styles_ts-PercentLineInner-pzkf9m9",
  vars: {
    "pzkf9m9-0": [props => props.percent, "%"]
  }
});
export const rulesContainer = "omponents__Input__components__RuledPasswordInput__RuledPassword_styles_ts-rulesContainer-rl14xp6";
export const rulesElement = `${"omponents__Input__components__RuledPasswordInput__RuledPassword_styles_ts-rulesElement-r1jmt51h"}
${textSmall}
`;

require("./RuledPassword.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./RuledPassword.styles.ts");